import { Badge } from "@/components/ui/badge.jsx";
import { getParameterStatus } from "@/lib/parameter-status-utils.js";
import {
  getStatusBadgeClass,
  getStatusDotClass,
} from "@/lib/status-utils.js";

/**
 * Parameter status badge component
 * Displays a colored badge representing the parameter's status
 * @param {Object} param - Parameter object with currentValue, alarmSetPoints, status, displayType
 * @returns {JSX.Element} Status badge component
 */
export default function ParameterStatusBadge({ param }) {
  const statusInfo = getParameterStatus(param);

  return (
    <Badge
      variant='status'
      className={getStatusBadgeClass(statusInfo.label)}>
      <span
        className={getStatusDotClass(
          statusInfo.label,
          "h-1.5 w-1.5"
        )}
        aria-hidden='true'
      />
      {statusInfo.label}
    </Badge>
  );
}
